/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-form-18" size="18" style="display: none;">
  <svg>
    <defs>
      <g id="checkbox-default">
        <path d="M15,2a1.013,1.013,0,0,1,1,1V15a1.013,1.013,0,0,1-1,1H3a1.013,1.013,0,0,1-1-1V3A1.013,1.013,0,0,1,3,2H15m0-2H3A3.009,3.009,0,0,0,0,3V15a3.009,3.009,0,0,0,3,3H15a3.009,3.009,0,0,0,3-3V3a3.009,3.009,0,0,0-3-3h0Z"></path>
      </g>
      <g id="checkbox-checked">
        <path d="M15,2a1.013,1.013,0,0,1,1,1V15a1.013,1.013,0,0,1-1,1H3a1.013,1.013,0,0,1-1-1V3A1.013,1.013,0,0,1,3,2H15m0-2H3A3.009,3.009,0,0,0,0,3V15a3.009,3.009,0,0,0,3,3H15a3.009,3.009,0,0,0,3-3V3a3.009,3.009,0,0,0-3-3h0Z"></path>
        <rect x="5.299" y="8.689" width="2.038" height="5.716" rx="1.019" ry="1.019" transform="translate(-6.314 7.85) rotate(-45)"></rect>
        <path d="M7.1,13.618h0A1.022,1.022,0,0,1,7,12.18l5.975-7.2a1.022,1.022,0,0,1,1.437-.1h0a1.022,1.022,0,0,1,.1,1.437l-5.975,7.2A1.022,1.022,0,0,1,7.1,13.618Z" fill-rule="evenodd"></path>
      </g>
    </defs>
  </svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
